import { apiClient } from '@/core/api/client';
import { ensureAnonSessionId } from '@/shared/utils/anonymousSession';

export type DiscoverySource =
  | 'DIRECTORY_SEARCH'
  | 'NAVIGATOR'
  | 'FP_QA'
  | 'FAVORITES'
  | 'MESSAGES'
  | 'DIRECT_PROFILE'
  | 'OTHER';

export const parseDiscoverySource = (value: string | null): DiscoverySource => {
  const sources: DiscoverySource[] = [
    'DIRECTORY_SEARCH',
    'NAVIGATOR',
    'FP_QA',
    'FAVORITES',
    'MESSAGES',
    'DIRECT_PROFILE',
    'OTHER',
  ];
  return value && sources.includes(value as DiscoverySource)
    ? value as DiscoverySource
    : 'DIRECT_PROFILE';
};

type ProfileViewResponse = {
  engagementEventId: string;
  created: boolean;
};

export const recordProviderProfileView = async (
  providerId: string,
  searchContextId?: string,
  discoverySource: DiscoverySource = 'DIRECT_PROFILE',
): Promise<ProfileViewResponse> => {
  const { data } = await apiClient.post<ProfileViewResponse>(
    `/providers/${providerId}/profile-views`,
    {
      anonSessionId: ensureAnonSessionId(),
      searchContextId,
      discoverySource,
    },
  );
  return data;
};
